import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { BlockType, Define } from '@appblocks/codegeneration/types';

export default class MbedTLS extends BaseFeature {
    constructor() {
        super();
        this.id = 'mbedtls';

        this.files = [
            'src/ca_certificates.h',
        ];
    }

    getDependencies() {
        return ['sock'];
    }

    getDefines(): Array<Define> {
        const defines = [
            {
                name: 'DHCP_DEBUG_PRINT',
                value: '1',
            },
            {
                name: 'DHCP_POST_FAIL_DELAY',
                value: '30',
            },
            {
                name: 'DHCP_WAIT_TIME',
                value: '8',
            },
        ];

        return defines;
    }

    getCodeBlocks() {
        const blocks = [];

        blocks.push({
            location: 'PRJ_CONF',
            blockType: BlockType.CODE,
            template: `
# TLS            
CONFIG_MBEDTLS=y
CONFIG_MBEDTLS_BUILTIN=y
CONFIG_MBEDTLS_ENABLE_HEAP=y
CONFIG_NET_SOCKETS_SOCKOPT_TLS=y
CONFIG_NET_SOCKETS_TLS_MAX_CONTEXTS=2
CONFIG_MBEDTLS_PEM_CERTIFICATE_FORMAT=y
CONFIG_MBEDTLS_SERVER_NAME_INDICATION=y
CONFIG_MBEDTLS_AES_ROM_TABLES=y
CONFIG_MBEDTLS_TLS_VERSION_1_2=y

CONFIG_MBEDTLS_HEAP_SIZE=48000
CONFIG_MBEDTLS_SSL_MAX_CONTENT_LEN=16384
`,
        });

        blocks.push({
            location: 'GLOBAL_INCLUDES',
            blockType: BlockType.CODE,
            template: `
#include <zephyr/net/tls_credentials.h>
#include "ca_certificates.h"`,
        });

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
for (int i = 0; i < ARRAY_SIZE(ca_certificates); i++) {
    tls_credential_add(CA_CERTIFICATE_TAG + i,
                TLS_CREDENTIAL_CA_CERTIFICATE,
                ca_certificates[i],
                strlen(ca_certificates[i]) + 1);
}
`,
        });

        return blocks;
    }
}
